import * as React from 'react';

export const ModalHeader = (props: any) => <div className="modal-header">{props.children}</div>;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalHeader.tsx